var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.step.sentence)}}),_c('InlineIngredients',{attrs:{"ingredients":_vm.mappedIngredients}}),_c('InlineTips',{attrs:{"tips":_vm.step.tips}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }